<template>
  <div id="weeconnectpay-app">
    <SplitScreenSignIn v-if="!isAuthenticated"/>
    <LogViewer v-else-if="debugMode"/>
  </div>
</template>

<script>
import axios from 'axios';
import SplitScreenSignIn from './components/SplitScreenSignIn.vue'
import LogViewer from './components/LogViewer.vue'

let _integrationApiBaseUrl;
let _apiBaseUrl;
let _restUrl;

// eslint-disable-next-line no-undef
if (window.weeconnectpayVueData.gitpodBackendWorkspaceUrl) {
  // eslint-disable-next-line no-undef
  _apiBaseUrl = window.weeconnectpayVueData.gitpodBackendWorkspaceUrl;
  // eslint-disable-next-line no-undef
  _integrationApiBaseUrl = window.weeconnectpayVueData.pluginUrl;
  // eslint-disable-next-line no-undef
  _restUrl = window.weeconnectpayVueData.restUrl;
} else if (process.env.NODE_ENV === 'development') {
  _apiBaseUrl = 'https://weeconnect-api.test';
  _integrationApiBaseUrl = 'https://weeconnect-wp.test';
  _restUrl = 'https://weeconnect-wp.test/wp-json';
} else {
  // We import it from WP localize script.
  // eslint-disable-next-line no-undef
  _integrationApiBaseUrl = window.weeconnectpayVueData.pluginUrl;
  _apiBaseUrl = 'https://apidev.weeconnectpay.com';
  // eslint-disable-next-line no-undef
  _restUrl = window.weeconnectpayVueData.restUrl;
}
const integrationApiBaseUrl = _integrationApiBaseUrl;
const apiBaseUrl = _apiBaseUrl;
const restUrl = _restUrl;

const weeconnectpayApi = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    Accept: 'application/json',
    Authorization: 'bearer ' + localStorage.getItem("authToken")
  }
})

const weeconnectpayPublicApi = axios.create({
  baseURL: apiBaseUrl,
  header: {Accept: 'application/json'}
})

const wpApi = axios.create({
  baseURL: restUrl,
  headers: {Accept: 'application/json', 'X-WP-Nonce': window.weeconnectpayVueData.nonce || ''}
})

const pluginApi = axios.create({
  baseURL: integrationApiBaseUrl,
  header: {Accept: 'application/json'}
})

export default {
  name: 'App',
  components: {
    SplitScreenSignIn,
    LogViewer
  },
  data() {
    return {
      debugMode: false,
      isAuthenticated: false
    }
  },
  provide: {
    httpApi: weeconnectpayApi,
    httpPublicApi: weeconnectpayPublicApi,
    httpIntegrationApi: pluginApi,
    wpApi: wpApi,
  },
  mounted() {
    this.debugMode = window.weeconnectpayVueData.debugMode === "1" || window.weeconnectpayVueData.debugMode === true;
    this.isAuthenticated = window.weeconnectpayVueData.isAuthenticated === "1" || window.weeconnectpayVueData.isAuthenticated === true;
  }
}
</script>

<style>
#weeconnectpay-app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
